import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import LoadingScreen from "./components/LoadingScreen";
import { BrowserRouter as Router } from "react-router-dom";
import "./i18n";
// import PiwikPro from '@piwikpro/react-piwik-pro';

// PiwikPro.initialize('46bbd988-9ec4-4005-bcf1-647fa992281a', 'https://batkoblazej.containers.piwik.pro');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <React.StrictMode>
      <Suspense fallback={<LoadingScreen />}>
        <App />
      </Suspense>
    </React.StrictMode>
  </Router>
);
